/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Fact_DaysInputs */

const en_us2_profile_fact_days = /** @type {(inputs: Profile_Fact_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const pt_br2_profile_fact_days = /** @type {(inputs: Profile_Fact_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const es_419_profile_fact_days = /** @type {(inputs: Profile_Fact_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const pt_pt2_profile_fact_days = /** @type {(inputs: Profile_Fact_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const fr_fr2_profile_fact_days = /** @type {(inputs: Profile_Fact_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const de_de2_profile_fact_days = /** @type {(inputs: Profile_Fact_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const it_it2_profile_fact_days = /** @type {(inputs: Profile_Fact_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

/**
* | output |
* | --- |
* | "{count}×" |
*
* @param {Profile_Fact_DaysInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_fact_days = /** @type {((inputs: Profile_Fact_DaysInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Fact_DaysInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_fact_days(inputs)
	if (locale === "es-419") return es_419_profile_fact_days(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_fact_days(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_fact_days(inputs)
	if (locale === "de-DE") return de_de2_profile_fact_days(inputs)
	if (locale === "it-IT") return it_it2_profile_fact_days(inputs)
	return en_us2_profile_fact_days(inputs)
});
export { profile_fact_days as "profile.fact_days" }